// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"yr-z","giftOrPromoSelector":"zr-z","disabled":"Ar-z","subTitle":"Br-z","selectShipAddressMessage":"Cr-z","changePayment":"Dr-z"};